import script from "./terminal-pay.vue?vue&type=script&lang=tsx&setup=true"
export * from "./terminal-pay.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__